import jwtDecode from 'jwt-decode';
import { ApiRequestError, RefreshTokenExpiredError } from './axios_api_client'

export default function (originalError, axios) {
  const originalRequest = originalError.config;

  if (!originalRequest.url.includes('/api/')) return Promise.reject(originalError);
  if (originalRequest.url == '/api/access_tokens') {
    return Promise.reject(new RefreshTokenExpiredError(originalError.message))
  }
  if (originalRequest._retry) {
    return Promise.reject(new ApiRequestError(originalError.message))
  }

  const apiToken = document.querySelector('[name="api-token"]');

  originalRequest._retry = true;
  const refreshToken = jwtDecode(apiToken.content).refresh_token;

  return axios
    .post('/api/access_tokens', {}, {
      headers: { 'Authorization': `Bearer ${refreshToken}` }
    })
    .then(res => {
      if (res.status == 201) {
        apiToken.content = res.data.access_token
        originalRequest.headers = {
          ...originalRequest.headers,
          ...{ 'Authorization': `Bearer ${res.data.access_token}` }
        }
        return axios(originalRequest);
      }
    })
}
